export const BASE_API_URL = "https://admin.smartportal.uz/api";
